import React from "react";

type TableHeaderCellProps = React.DetailedHTMLProps<
  React.ThHTMLAttributes<HTMLTableHeaderCellElement>,
  HTMLTableHeaderCellElement
> & {
  children: React.ReactElement;
};

/** Renders Table header cell */
function TableHeaderCell(props: TableHeaderCellProps) {
  const { children } = props;
  return <th {...props}>{children}</th>;
}

export default TableHeaderCell;
